<template>
	<div id="list-menus">
		<h1>Menus</h1>
		<b-list-group>
			<b-list-group-item
				class="d-flex justify-content-between align-items-center"
				v-for="(menu,index) in menusList"
				:key="index"
			>
				<b-container>
					<b-row>
						<b-col lg="8">{{menu.title}}</b-col>
						<b-col>
							<div class="mt-3">
								<b-button-group>
									<b-button variant="info" @click="flipViewFlags(index)">Ver</b-button>
									<b-button variant="info" @click="flipEditFlag(index,menu)">Alterar</b-button>
									<b-button variant="info" @click="$bvModal.show('my-modal-event'+menu.id)">Remover</b-button>
                  <b-modal :id="'my-modal-event'+menu.id" title="Apagar Menu" @ok="deleteMenu(menu.id)">Apagar {{menu.title}} ?</b-modal>
								</b-button-group>
							</div>
						</b-col>
					</b-row>
					<b-row lg="10">
						<b-col>
							<div v-if="viewingFlags[index]">
                <form-menu editingMode="view" :menu="menu"></form-menu>
							</div>
							<div v-if="editingFlag - 1 == index">
                <form-menu editingMode="edit" :menu="menu"></form-menu>
							</div>
						</b-col>
					</b-row>
				</b-container>
			</b-list-group-item>
		</b-list-group>
	</div>
</template>

<script>
import api from "../../api";
import { jsonIn } from "../../utils/snakeCamel"
import formMenu from './formMenu'
import { mapActions, mapGetters } from 'vuex';
export default {
  name: "listMenus",
  components:{formMenu},
	data() {
		return {
			viewingFlags: [],
			editingFlag: 0
		};
	},
	mounted() {
		this.refreshData();
  },
  computed:{
    ...mapGetters(['menusList'])
  },
	methods: {
    ...mapActions(['refreshMenus']),
    deleteMenu(index){
      api.deleteMenu({id: index}).then(() =>
      this.refreshData()
      )
    },
		refreshData() {
    this.refreshMenus().then(() => {
      for (var i = 0; i < this.menusList.length; i++) {
        this.viewingFlags[i] = false;
      }
    })
		},
		flipViewFlags: function(index) {
			if (index + 1 !== this.editingFlag) {
      this.$set(this.viewingFlags, index, !this.viewingFlags[index]);
      }
		},
		flipEditFlag: function(index, tour) {
			if (index + 1 !== this.editingFlag) {
				this.viewingFlags[index] = false;
				this.editingFlag = index + 1;
			} else {
				this.editingFlag = 0;
			}
		}
	}
};
</script>
<style script="css">
#list-menus {
	text-align: left;
}
</style>


